/* ------------------------------------------------------------------
フォローボタン、フォロー済みの場合は「フォロー中」に変更
--------------------------------------------------------------------- */
function initializeFollowBtn() {
  if (document.querySelector(".jsFollow")) {
    $.ajax({
      url: Routes.async_info_follow_path(),
      type: "GET",
      dataType: "json",
      success(data) {
        data.following_ids.forEach((user_id) => {
          $(`.jsFollow[data-id=${user_id}]`).addClass("isAdded");
        });
      },
      error(_XMLHttpRequest, _textStatus, _errorThrown) {
        console.log("error");
      },
    });
  }
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeFollowBtn;
